import request from "@/router/axios"
export const get = (params) => {
    return request({
        url: `/api/jy/bill/get`,
        method: 'get',
        params
    })
}
